import 'css-chunksrc/client/scenes/accountCreationConfirmation/styles.scss';export default {
  "accountCreationConfirmation": "_accountCreationConfirmation_hf2hu_1",
  "loader": "_loader_hf2hu_5",
  "loaderMain": "_loaderMain_hf2hu_19"
};